import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getPerformance } from "firebase/performance";

import { BaseController } from './BaseController';

export default class FirebaseController extends BaseController {
    id = 'FirebaseController';
    
    init() {
        this.appConfig = {
            apiKey: "AIzaSyDhla3iETRi6JO3h5qJ45CcMfhoKaY9MEo",
            authDomain: "la-island.firebaseapp.com",
            databaseURL: "https://la-island.firebaseio.com",
            projectId: "la-island",
            storageBucket: "la-island.appspot.com",
            messagingSenderId: "473823975511",
            appId: "1:473823975511:web:a9db32967611a447beab12",
            measurementId: "G-SVEGC5F3BB"
        };

        this.app = initializeApp(this.appConfig);

        this.analytics = getAnalytics(this.app);
        this.perf = getPerformance(this.app);
    }
}